// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd78d800","633":"88fc2f19"}[chunkId] + ".chunk.js";
};